
import { mutations } from '@/assets/scripts/store'

export default {
  name: 'DetailEvent',

  head() {
    return this.popinData ? this.popinData.metaTags : null
  },

  computed: {
    popinData: mutations.getPopinData,
  },
}
